import type { BoardSort } from '../../helpers/board-sort.helper';

/**
 * What the project board's sort toggle shows, keyed by the order the board is sorted in NOW.
 * Label and icon name what the next click does (Anke, 2026-10-07). The classes are matched by
 * `buttons.css` (`button.toggle-board-sort`, `.to-milestone`), the labels by `de.json`
 * (`toolbar.*`); `board-sort-toggle.assets.test.ts` reads both files, so a typo on either side
 * turns red. Kept beside the view, not in board-sort.helper.ts: it is presentation of this one
 * view, the helper holds only the sort values and the storage key.
 */
export const BOARD_SORT_TOGGLE: Record<BoardSort, { cssClass: string; labelKey: string }> = {
    milestone: { cssClass: 'toggle-board-sort', labelKey: 'toolbar.boardSortAlphabetical' },
    alphabetical: { cssClass: 'toggle-board-sort to-milestone', labelKey: 'toolbar.boardSortMilestone' },
};
